import type { TabId } from '../types';

// Sticky underline tabs (DC §3). Active tab carries the teal underline bar.
export function TabsBar({
  tabs,
  value,
  onChange,
}: {
  tabs: Array<{ value: TabId; label: string }>;
  value: TabId;
  onChange: (v: TabId) => void;
}) {
  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        background: 'var(--background)',
        borderBottom: '1px solid var(--border)',
        padding: '0 clamp(16px, 5vw, 64px)',
      }}
    >
      <div style={{ display: 'flex', gap: 28 }}>
        {tabs.map((t) => {
          const active = t.value === value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onChange(t.value)}
              style={{
                position: 'relative',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: '16px 0',
                fontSize: 14,
                fontFamily: 'inherit',
                fontWeight: active ? 700 : 500,
                color: active ? 'var(--foreground)' : 'var(--muted-foreground)',
              }}
            >
              {t.label}
              {active && (
                <span
                  style={{
                    position: 'absolute',
                    bottom: -1,
                    left: 0,
                    right: 0,
                    height: 3,
                    background: 'var(--alpha-teal)',
                    borderRadius: '99px 99px 0 0',
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
